<template>
  <b-modal
    id="add-extra-modal"
    ref="addExtraModal"
    title="Ajouter Frais Extra"
    hide-footer
    @hidden="resetForm"
  >
    <div v-if="order" class="p-1">
      <!-- Order Summary -->
      <div class="bg-light p-1 rounded mb-2">
        <b-row>
          <b-col cols="6">
            <small class="text-muted d-block">Bordereau</small>
            <span class="font-weight-bold">{{ order.id }}</span>
          </b-col>
          <b-col cols="6">
            <small class="text-muted d-block">Destinataire</small>
            <span class="font-weight-bold">{{ order.name }}</span>
          </b-col>
        </b-row>
        <b-row class="mt-1">
          <b-col cols="6">
            <small class="text-muted d-block">Frais actuels</small>
            <span class="font-weight-bold text-success">{{ formatPrice(order.price_delivery) }} DT</span>
          </b-col>
          <b-col cols="6">
            <small class="text-muted d-block">Dépôt</small>
            <span class="font-weight-bold">{{ order.depot_name }}</span>
          </b-col>
        </b-row>
      </div>

      <!-- Form -->
      <b-form @submit.prevent="submit">
        <b-form-group
          label="Montant Extra à ajouter (DT)"
          label-for="extra-amount"
        >
          <b-form-input
            id="extra-amount"
            v-model="form.extra_amount"
            type="number"
            step="0.001"
            min="0.001"
            required
            placeholder="Ex: 5.000"
            autofocus
          />
        </b-form-group>

        <!-- Calculation Display -->
        <div class="alert alert-info py-1 mb-2">
          <div class="d-flex justify-content-between align-items-center mb-50">
            <span>Frais Livraison Actuel:</span>
            <span>{{ formatPrice(order.price_delivery) }} DT</span>
          </div>
          <div class="d-flex justify-content-between align-items-center mb-50">
            <span>Extra à ajouter:</span>
            <span class="text-primary">+ {{ formatPrice(form.extra_amount) }} DT</span>
          </div>
          <hr class="my-50 border-white opacity-25">
          <div class="d-flex justify-content-between align-items-center font-weight-bolder">
            <span>Nouveau Total:</span>
            <span class="h5 mb-0 text-dark">{{ formatPrice(newTotal) }} DT</span>
          </div>
        </div>

        <b-form-group
          label="Raison / Commentaire"
          label-for="extra-reason"
        >
          <b-form-textarea
            id="extra-reason"
            v-model="form.reason"
            placeholder="Pourquoi ajoutez-vous ces frais ?"
            rows="2"
            max-length="500"
          />
        </b-form-group>

        <!-- Footer -->
        <div class="d-flex justify-content-end mt-2 pt-1 border-top">
          <b-button
            variant="outline-secondary"
            class="mr-1"
            @click="close"
          >
            Annuler
          </b-button>
          <b-button
            type="submit"
            variant="primary"
            :disabled="loading || !form.extra_amount || form.extra_amount <= 0"
          >
            <b-spinner v-if="loading" small class="mr-50" />
            Confirmer l'ajout
          </b-button>
        </div>
      </b-form>
    </div>
  </b-modal>
</template>

<script>
import {
  BModal,
  BForm,
  BFormGroup,
  BFormInput,
  BFormTextarea,
  BButton,
  BRow,
  BCol,
  BSpinner,
} from 'bootstrap-vue'
import { mapActions } from 'vuex'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BModal,
    BForm,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BButton,
    BRow,
    BCol,
    BSpinner,
  },
  data() {
    return {
      order: null,
      loading: false,
      form: {
        extra_amount: '',
        reason: '',
      },
    }
  },
  computed: {
    newTotal() {
      if (!this.order) return 0
      const current = parseFloat(this.order.price_delivery) || 0
      const extra = parseFloat(this.form.extra_amount) || 0
      return current + extra
    },
  },
  methods: {
    ...mapActions('extraFees', ['addExtraFee']),
    open(order) {
      this.order = order
      this.$refs.addExtraModal.show()
    },
    close() {
      this.$refs.addExtraModal.hide()
    },
    resetForm() {
      this.order = null
      this.form.extra_amount = ''
      this.form.reason = ''
    },
    formatPrice(value) {
      if (!value) return '0.000'
      return parseFloat(value).toFixed(3)
    },
    submit() {
      this.$bvModal
        .msgBoxConfirm(`Êtes-vous sûr d'ajouter ${this.formatPrice(this.form.extra_amount)} DT de frais extra ?`, {
          title: 'Confirmation',
          okTitle: 'Oui, confirmer',
          cancelTitle: 'Annuler',
        })
        .then(value => {
          if (value) {
            this.executeSubmit()
          }
        })
    },
    executeSubmit() {
      this.loading = true
      const payload = {
        order_id: this.order.id,
        extra_amount: this.form.extra_amount,
        reason: this.form.reason,
      }

      this.addExtraFee(payload)
        .then(() => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Succès',
              icon: 'CheckIcon',
              variant: 'success',
              text: 'Frais extra ajoutés avec succès.',
            },
          })
          this.$emit('success')
          this.close()
        })
        .catch(error => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Erreur',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
              text: error.response?.data?.detail || 'Une erreur est survenue.',
            },
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>
